import { RESET_STATE, SET_ICEPACKS_STATES, SET_IS_ICEPACKS_STATES_LOADING, SET_PAGINATION } from './actions';

export const initialState = {
	icepacksStates: [],
	isIcepacksStatesLoading: false,
	pagination: null,
};

const icepacksStatesContainerReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_ICEPACKS_STATES:
			return {
				...state,
				icepacksStates: payload,
			};
		case SET_IS_ICEPACKS_STATES_LOADING:
			return {
				...state,
				isIcepacksStatesLoading: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default icepacksStatesContainerReducer;
